import React, { useState } from "react";
import { Avatar, List, Space, Typography, Badge, Button, Tooltip } from "antd";
import { MessageOutlined, SmileOutlined } from "@ant-design/icons";
import CommentDrawer from "./CommentDrawer";
import styled from "styled-components";
import { getUserList, getUserInfo } from "redux/selectors";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import dayjs from "dayjs";

const Drawer = styled.div`
  .ant-badge-count,
  .ant-badge-dot,
  .ant-badge .ant-scroll-number-custom-component {
    position: absolute;
    top: -5px;
    left: -22px;
    transform: translate(50%, -50%);
    transform-origin: 100% 0%;
  }
  .ant-list-item-meta {
    display: flex;
    flex: 1 1;
    align-items: center;
    max-width: 100%;
  }
  .ant-spin-container {
    max-height: 200px;
  }
  .ant-list-item-action {
    flex: 0 0 auto;
    margin-right: 20px;
    padding: 0;
    font-size: 0;
    list-style: none;
  }
`;

const { Text } = Typography;

const SUPER_ADMIN_ROLE_ID = "2";

const BirthdaySpotLight = ({ userList, userInfo }) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const userRoles = Array.isArray(userInfo?.role_id)
    ? userInfo.role_id.map(String)
    : [String(userInfo?.roleId ?? "")];

  const isSuperAdmin = userRoles.includes(SUPER_ADMIN_ROLE_ID);

  const currentUserOffice = Array.isArray(userInfo?.managingoffice)
    ? userInfo.managingoffice[0]
    : userInfo?.managingoffice;

  const filterByCountry = (list = []) => {
    if (isSuperAdmin) return list;
    if (!currentUserOffice) return [];

    return list.filter((user) => {
      const userOffice = Array.isArray(user.managingoffice)
        ? user.managingoffice[0]
        : user.managingoffice;
      return userOffice === currentUserOffice;
    });
  };

  // Filter today's birthdays from the country-filtered list
  const todayBirthdayUsers = filterByCountry(userList ?? []).filter(
    (user) =>
      user.dateofbirth &&
      user.statusid === "1" &&
      dayjs(user.dateofbirth).utc().format("MM-DD") === dayjs().format("MM-DD")
  );


  return (
    <Drawer>
      <List
        header={<Text strong>Today's Birthday Spotlight</Text>}
        dataSource={todayBirthdayUsers}
        itemLayout="horizontal"
        style={{ maxHeight: 350, overflowY: "auto" }}
        renderItem={(item) => (
          <List.Item

          >
            <List.Item.Meta
              avatar={
                <Avatar src={item.profileurl} size={48}>
                  {!item.profileurl && item.fullname?.charAt(0).toUpperCase()}
                </Avatar>
              }
              title={<Text strong>{item.fullname}</Text>}
              description={
                <Space direction="vertical" size={4}>
                  <Text type="secondary">{item.rolename[0]}</Text>

                  {Array.isArray(item.reactions) && item.reactions.length > 0 && (
                    <Space wrap>
                      {item.reactions.map((r, i) => (
                        <Button key={i} size="small">
                          {r.emoji} {r.count}
                        </Button>
                      ))}
                    </Space>
                  )}
                </Space>
              }
            />
          </List.Item>
        )}
      />

      <CommentDrawer
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        user={selectedUser}
      />
    </Drawer>
  );
};

const mapStateToProps = (state) => ({
  userList: getUserList(state),
  userInfo: getUserInfo(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BirthdaySpotLight);